import { Flex, Typography } from "antd"
import cls from "classname"

import InfoTooltip from "../../../../Components/InfoTooltip/InfoTooltip"
import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import Images from "../../../../Images"
import { paymentMethodsImages } from "../../utils/paymentMethods"
import { formatAmount, formatCount, getDefaultColumns } from "../Table/columns"

const { Text } = Typography

export const getColumns = ({ t, expandedKeys, dataSource } = {}) => [
  {
    key: "card_type",
    title: t("Card type"),
    dataIndex: "card_type",
    render: (_, record) => {
      const isWalletRow = record?.row_type === "wallet"
      const isOtherSection = record?.card_type === "other"
      const image = getRowIcon(record)
      const text = getRowName(record)
      const isExpandable = record?.wallets?.length > 0 && !isWalletRow
      const isExpanded = expandedKeys.includes(record?.card_type)

      if (record?.unique_id === "other_divider") {
        return (
          <Text type="secondary" style={{ fontSize: "12px", fontWeight: 600 }}>
            OTHER
          </Text>
        )
      }

      return (
        <Flex gap={8} style={isWalletRow && !isOtherSection ? { paddingLeft: "28px" } : {}}>
          {image && <img src={image} alt={_} width={20} height={20} />}
          <Text strong>{text}</Text>
          {showsShopifyPaymentsTooltip(record, dataSource) && (
            <InfoTooltip title={t(SHOPIFY_PAYMENTS_TOOLTIP)} placement="top" />
          )}
          {isExpandable && (
            <Icon
              type="chevron_down_small"
              className={cls("chevron_down", { expanded: isExpanded })}
            />
          )}
        </Flex>
      )
    }
  },
  {
    key: "transactions",
    title: t("Transactions"),
    dataIndex: "transactions",
    align: "right",
    render: (_, record) => {
      if (record?.isDivider) return null
      return (
        <Flex gap={2} vertical={true}>
          <Text strong>{formatCount(record?.["transactions_count"])}</Text>
          <Text type="secondary" strong>
            <Private>{formatAmount(record?.["transactions_amount"])}</Private>
          </Text>
        </Flex>
      )
    }
  },
  ...getDefaultColumns({ t })
]

const ICON_PLACEHOLDER = paymentMethodsImages.Other

const toIconKey = (value) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/_/g, " ")
    .trim()

const paymentMethodIconsByKey = Object.entries(paymentMethodsImages).reduce(
  (acc, [label, image]) => ({ ...acc, [toIconKey(label)]: image }),
  {}
)

export const getRowIcon = (record) => {
  if (record?.icon_url) return record.icon_url

  const isWalletRow = record?.row_type === "wallet"
  const key = toIconKey(isWalletRow ? record?.wallet_type : record?.card_type)

  return paymentMethodIconsByKey[key] ?? Images[key] ?? ICON_PLACEHOLDER
}

export const SHOPIFY_PAYMENTS_TOOLTIP =
  "Shopify did not provide the card brand or wallet details, so these transactions are grouped under Shopify Payments instead of Visa, Mastercard, Amex, etc."

const SHOPIFY_PAYMENTS_KEY = toIconKey("Shopify Payments")

export const showsShopifyPaymentsTooltip = (record, dataSource) => {
  if (dataSource !== "shopify") return false
  if (record?.row_type === "wallet") return false

  return toIconKey(record?.card_type) === SHOPIFY_PAYMENTS_KEY
}

export const getRowName = (record) => {
  const isWalletRow = record?.row_type === "wallet"

  return isWalletRow ? record?.wallet_type : record?.card_type
}
